import React from "react";

import FormElement from "components/FormElement/FormElement";
import Button from "components/Button/Button";
// import Select from "components/Select/Select";
// import ProfilePhoto from "components/ProfilePhoto/ProfilePhoto";

import styles from "./OrgSiteDept.module.scss";

import { country_list } from "./utils";

// const country_list_small = [
//   { id: "40",
//     name: "Canada"
//   },
//   { id: "235",
//     name: "United States of America"
//   },
// ];

const OrgSiteDeptEditForm = props => {
    const formData = props.formData;
    const setFormData = props.setFormData;
    const updateOrgAction = props.updateOrgAction;
    const updateSiteAction = props.updateSiteAction;
    const isSuper = props.isSuper;

    const handleChange = e => {
        if (
            e.target.dataset &&
            e.target.dataset.name &&
            e.target.dataset.value
        ) {
            // for country
            setFormData({
                ...formData,
                [e.target.dataset.name]: e.target.dataset.value
            });
        } else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            });
        }
    };

    const handleSave = () => {
        if (formData.company_name === '') {
            return false;
        }
        window.scrollTo(0, 0);
        if (formData.type === "site") {
            updateSiteAction({
                ...formData,
                active: true,
                name: formData.company_name
            });
        }

        if (formData.type === "org") {
            updateOrgAction({
                ...formData,
                active: true,
                name: formData.company_name
            });
        }
    };

    // const countryLabels = country_list.reduce((acc, curr) => {
    //     acc[curr.id] = curr.name;
    //     return acc;
    // }, {});

    const isOrg = props.formData.type === 'org' ? true : false;

    return (
        <>
            <FormElement labelText="NAME" htmlFor="company_name">
                <input
                    placeholder="Company Name"
                    name="company_name"
                    type="text"
                    maxLength="70"
                    value={formData.company_name}
                    onChange={e => handleChange(e)}
                />
            </FormElement>

            <FormElement labelText="ADDRESS 1" htmlFor="address_1">
                <input
                    placeholder="Company Address Line 1"
                    type="text"
                    name="address_1"
                    id="address_1"
                    value={formData.address_1}
                    onChange={e => handleChange(e)}
                />
            </FormElement>

            <FormElement labelText="ADDRESS 2" htmlFor="address_2">
                <input
                    placeholder="Company Address Line 2"
                    type="text"
                    name="address_2"
                    id="address_2"
                    value={formData.address_2}
                    onChange={e => handleChange(e)}
                />
            </FormElement>

            <FormElement labelText="CITY" htmlFor="city">
                <input
                    placeholder="City"
                    id="city"
                    name="city"
                    type="text"
                    value={formData.city}
                    onChange={e => handleChange(e)}
                />
            </FormElement>

            <FormElement labelText="REGION/STATE" htmlFor="region">
                <input
                    placeholder="Region"
                    name="region"
                    id="region"
                    type="text"
                    value={formData.region}
                    onChange={e => handleChange(e)}
                />
            </FormElement>

            <FormElement labelText="COUNTRY" htmlFor="country">
                <div className={styles.input_holder}>
                    <select className={styles.input} name="country_code" value={props.country} onChange={handleChange}>
                        {country_list.map(item => (
                            <option key={item.id} data-name="country_code" data-value={item.id} value={item.id}>{item.name}</option>
                        ))}
                    </select>
                </div>
            </FormElement>

            {/* <FormElement labelText="COUNTRY" htmlFor="country">
                <Select
                    value={props.country || "Please Select a country"}
                    placeholder="Country"
                    name="country"
                    onClick={e => handleChange(e)}
                    dropdownToggleRef={props.countryDropdownToggleRef || null}
                    labels={countryLabels}
                >
                    {country_list_small.map(item => (
                        <li
                            key={item.id}
                            data-value={item.id}
                            data-name="country_code"
                        >
                            {item.name}
                        </li>
                    ))}
                </Select>
            </FormElement> */}

            <FormElement labelText="POSTAL CODE" htmlFor="postal_code">
                <input
                    placeholder="Postal Code"
                    type="text"
                    id="postal_code"
                    name="postal_code"
                    value={formData.postal_code}
                    onChange={e => handleChange(e)}
                />
            </FormElement>
            {/* <FormElement labelText="LOGO (optional)" htmlFor="profile_photo">
                <ProfilePhoto state={formData} setState={setFormData} />
            </FormElement> */}

            {(isSuper && isOrg) ?
            <>
                <FormElement labelText="SITE LIMIT" htmlFor="site_limit">
                    <input
                        placeholder="Site Limit"
                        name="site_limit"
                        id="site_limit"
                        type="text"
                        value={formData.site_limit}
                        onChange={e => handleChange(e)}
                    />
                </FormElement>
            </>
            : ""
            }

            <br />
            <br />

            <div className={styles["org-site-bottom-buttons"]}>
                <Button
                    text="CLEAR"
                    color="secondary"
                    onClick={() =>
                        setFormData({
                            company_name: "",
                            id: "",
                            address_1: "",
                            type: "",
                            address_2: "",
                            city: "",
                            region: "",
                            country_code: "",
                            postal_code: "",
                            site_limit: "",
                            "profile-photo": "",
                            "profile-photo-filename": "Add/Upload New"                    
                        })
                    }
                />
                <Button
                    type="submit"
                    icon="fal fa-save"
                    text="SAVE CHANGES"
                    onClick={handleSave}
                />
            </div>
        </>
    );
};

export default OrgSiteDeptEditForm;
